import React from "react";

import classNames from "classnames";
import { graphql, useStaticQuery } from "gatsby";

import NavigationLink from "../navigationLink/navigationLink";

import "./headerButtons.scss";

interface HeaderButtonsProps {
  className?: string;
  group?: boolean;
  idPrefix?: string | null;
  small?: boolean;
}

const HeaderButtons: React.FC<HeaderButtonsProps> = ({
  className = undefined,
  small = false,
  group = false,
  idPrefix = null,
}) => {
  const data: { kontentItemSiteSettings: Queries.kontent_item_site_settings } = useStaticQuery(graphql`
    {
      kontentItemSiteSettings(system: {codename: {eq: "site_settings"}}) {
        elements {
          button_registration_text {
            value
          }
          button_registration_url {
            value {
              id
            }
          }
          button_donation_text {
            value
          }
          button_donation_url {
            value {
              id
            }
          }
          button_donation_external_url {
            value
          }
        }
      }
    }
  `);

  const btnDarkGreenCountries = ["de", "pl"];

  if (!data || !data.kontentItemSiteSettings) {
    return null;
  }

  const settings = data.kontentItemSiteSettings;

  const idPrefixString = idPrefix ? `${idPrefix}_` : "";

  if (settings.elements?.button_registration_url?.value?.length === 0 && settings.elements?.button_donation_url?.value?.length === 0) {
    return null;
  }

  return (
    <div
      className={classNames(
        "header-buttons",
        {
          "header-buttons--group": group,
        },
        className,
      )}
    >
      {
        (settings.elements?.button_registration_url?.value?.length ?? 0) > 0 && settings.elements?.button_registration_text?.value !== ""
          ? (
            <NavigationLink
              className={classNames(
                "btn btn-registration",
                {
                  "btn-sm": small,
                },
              )}
              href={settings.elements?.button_registration_url?.value?.[0]?.id}
              activeClassName={undefined}
              idName={`${idPrefixString}header-buttons_btn-primary`}
            >
              {settings.elements?.button_registration_text?.value}
            </NavigationLink>
          )
          : null
      }
      {
        ((settings.elements?.button_donation_url?.value?.length ?? 0) > 0 || settings.elements?.button_donation_external_url?.value)
        && settings.elements?.button_donation_text?.value !== ""
          ? (
            <NavigationLink
              className={classNames(
                "btn",
                {
                  "btn-donation": btnDarkGreenCountries.indexOf(process.env.GATSBY_SITE) !== -1 && !idPrefix,
                  "btn-inverted-donation": btnDarkGreenCountries.indexOf(process.env.GATSBY_SITE) === -1 || idPrefix !== null,
                  "btn-sm": small,
                },
              )}
              href={(settings.elements?.button_donation_url?.value?.length ?? 0) > 0
                ? settings.elements?.button_donation_url?.value?.[0]?.id
                : settings.elements?.button_donation_external_url?.value}
              activeClassName={undefined}
              idName={`${idPrefixString}header-buttons_btn-secondary`}
            >
              {settings.elements?.button_donation_text?.value}
            </NavigationLink>
          )
          : null
      }
    </div>
  );
};

export default HeaderButtons;
